import React from "react";
import PropTypes from "prop-types";
import { useRecommendedPlaylist } from "../hooks/useRecommendedPlaylist";
import { useAutoplayContext } from "../contexts/AutoplayContext";
import { useHandleVideoEnd } from "../hooks/useHandleVideoEnd";
import { useVideoAnalyticsContext } from "../contexts/VideoAnalyticsContext";
import { OrcaFullUI } from "./OrcaFullUI";
import { useOrcaCommonContext } from "../contexts/OrcaCommonContext";
import { OrcaWrapper } from "./OrcaWrapper";

export const VodPlayer = ({
  config,
  isSandbox,
  onVideoEnded,
  promoEnabled,
  onVideoRendered,
  orcaRef
}) => {
  const { autoplayState, isMotionReduced } = useAutoplayContext();

  const {
    initDuration,
    initializeNewVideo,
    resetVideoState,
    isFullscreen,
    isNativeIOSPlayer,
    setIsFullscreen
  } = useOrcaCommonContext();

  const { sendAnalyticsEvent } = useVideoAnalyticsContext();

  const { switchToNextVideo, willPlaythrough, hasNextRecVideo } =
    useRecommendedPlaylist(
      config,
      isSandbox,
      false, // isLive
      initDuration,
      isMotionReduced,
      initializeNewVideo,
      resetVideoState
    );

  const handleVideoEnd = useHandleVideoEnd({
    autoplayState,
    sendAnalyticsEvent,
    resetVideoState,
    willPlaythrough,
    switchToNextVideo,
    onVideoEnded,
    hasNextRecVideo,
    isFullscreen,
    isNativeIOSPlayer,
    setIsFullscreen
  });

  return (
    <OrcaWrapper config={config}>
      <OrcaFullUI
        onVideoRendered={onVideoRendered}
        config={config}
        promoEnabled={promoEnabled}
        handleVideoEnd={handleVideoEnd}
        ref={orcaRef}
      />
    </OrcaWrapper>
  );
};

VodPlayer.propTypes = {
  config: PropTypes.object.isRequired,
  isSandbox: PropTypes.bool,
  onVideoEnded: PropTypes.func,
  promoEnabled: PropTypes.bool,
  onVideoRendered: PropTypes.func,
  orcaRef: PropTypes.object
};
